import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import { MAIN_ROUTES } from "../../routing/main_routes";
import DeleteOrder from "../DeleteOrder/DeleteOrder";
import styles from './DetailedOptions.module.scss';

const DetailedOptions = ({id, setIsDetailedOptionsVisible, handleDeleteOrder, type, isApprovedOfferByCleaner}) => {
    const [selectedOption, setSelectedOption] = useState('');

    const navigate = useNavigate();

    const handleSelectOption = (option) => {
        setSelectedOption(option);
    }

    return (
        <>
            <ul className={styles.list}>
                <li
                    className={styles.list_item}
                    onClick={() => navigate(`${MAIN_ROUTES.ORDER_DETAILS}/${id}`)}
                >Переглянути деталі
                </li>
                <li
                    className={styles.list_item}
                    onClick={() => navigate(`${MAIN_ROUTES.ORDER_DETAILS}/${id}`, {state: {step: 'step2'}})}
                >Переглянути пропозиції
                </li>
                {
                    (type !== 'history' && !isApprovedOfferByCleaner) && <li
                        onClick={() => handleSelectOption('Видалити замовлення')}
                        className={styles.list_item}
                    >Видалити замовлення
                    </li>
                }
            </ul>

            {selectedOption === 'Видалити замовлення' &&
                <DeleteOrder
                    id={id}
                    setIsDetailedOptionsVisible={setIsDetailedOptionsVisible}
                    handleDeleteOrder={handleDeleteOrder}
                />}
        </>
    );
};

export default DetailedOptions;
